<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
    [responseArrayCallback]="responseArrayCallback" [cellDoubleClickedCallback]="cellDoubleClickedCallback"
    [pagerVisible]="false" [rowClassRules]="rowClassRules" [updateStatusType]="updateStatusType">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="organization-settings-add-new-tag-button" class="secondary-button"
        (click)="addNewTag()" *ngIf="!hasNewTagPermissions">
        <i class="fa fa-plus"></i>New Tag ...
    </button>
</ng-template>